import { jsx as _jsx } from "react/jsx-runtime";
import MuiIconButton from '@mui/material/IconButton';
import * as React from 'react';
import { Badge } from '../badge';
import { getIcon } from '../icon';
import { usePopoverProps } from '../popover';
import { useRubiksTheme } from '../theme';
import { Tooltip } from '../tooltip';
import { withVersion } from '../utils';
const IconButtonImpl = React.forwardRef((props, ref) => {
    const { icon, badge, iconProps: _iconProps, tooltip, tooltipPlacement, ...muiProps } = props;
    const iconColor = getColorProp(props.color);
    const Icon = icon ? getIcon(icon) : () => null;
    const iconProps = (() => {
        return {
            fontSize: props.size,
            ..._iconProps
        };
    })();
    return (_jsx(Tooltip, { bypass: !tooltip, title: tooltip, placement: tooltipPlacement, children: _jsx(MuiIconButton, { ref: ref, "data-role": "icon-button", ...muiProps, children: _jsx(Badge, { ...badge, children: muiProps.children ?? (_jsx(Icon, { color: iconColor, ...iconProps })) }) }) }));
});
export const IconButton = withVersion(IconButtonImpl, '1.0.0');
function getColorProp(color) {
    if (color === 'default') {
        return undefined;
    }
    return color;
}
export function useIconButtonPopoverProps(props) {
    const { ThemeProvider } = useRubiksTheme();
    const { theme, behaviour, ...iconButtonProps } = props;
    return usePopoverProps({
        disabled: props.disabled,
        label: ({ open, ...labelProps }) => {
            const color = getColorProp(iconButtonProps.color);
            const button = (_jsx(IconButton, { ...iconButtonProps, iconProps: {
                    color: color ?? (open ? 'primary' : undefined),
                    ...props.iconProps
                }, ...labelProps }));
            return theme ? (_jsx(ThemeProvider, { theme: theme, children: button })) : (button);
        },
        behaviour,
        'aria-label': props['aria-label']
    });
}
